import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import store from 'store2';

// HTTP only: constlending-api-next has no GraphQL subscriptions and no screen left subscribes.
const httpLink = createUploadLink({
  uri: process.env.REACT_APP_API_ENDPOINT,
});

// `apollo-require-preflight`: Apollo Server blocks a multipart/form-data request (every Upload
// variable) as CSRF unless the client declares this header; apollo-upload-client@14 does not add it.
const authLink = setContext((_, { headers }) => {
  const token = store.get('constitution-token');

  return {
    headers: {
      ...headers,
      authorization: token ? `LendingBearer ${token}` : '',
      'apollo-require-preflight': 'true',
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
